import LiveGamesList from "./liveGamesList/liveGamesList";
import "./liveGames.sass";

export default function LiveGames({seccion, ligaFut, showFilter}) {

  return (
    <LiveGamesList seccion={seccion} ligaFut={ligaFut} showFilter={showFilter}/>
  )
}